import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'

import { DATE_WEEKDAY_SHORT_FORMAT } from '../../../constants/date'
import { useDateLocale } from '../../../hooks'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import Text from '../../Text'
import { BirdviewControl } from '../BirdviewControl'
import {
  BIRDVIEW_SCOPE_OPTIONS,
  BIRDVIEW_VIEW_OPTIONS,
} from '../DashboardBirdview.constants'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_REFRESH,
  QA_NAME_DASHBOARD_BIRDVIEW_RESET_LAYOUT,
} from '../DashboardBirdview.constants.qa'
import { getBirdviewGreetingKey } from '../DashboardBirdview.utils'

import * as styles from './BirdviewHeader.module.css'

import RefreshIcon from '../../../icons/refresh.svg'

function BirdviewHeader({
  ScopeControl = null,
  ViewControl = BirdviewControl,
  actionsContainerRef,
  date,
  greetingName,
  isRefreshing,
  scope,
  view,
  onChangeScope,
  onChangeView,
  onRefresh,
  onResetLayout,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return (
    <header className={styles.header}>
      <div className={styles.intro}>
        <Text isSecondary Element='h1' className={styles.greeting}>
          {t(getBirdviewGreetingKey(date), { name: greetingName })}
        </Text>
        <Text isSecondary className={styles.date}>
          {format(date, DATE_WEEKDAY_SHORT_FORMAT, { locale })}
        </Text>
      </div>
      <div className={styles.controls}>
        {ViewControl ? (
          <ViewControl
            options={BIRDVIEW_VIEW_OPTIONS}
            value={view}
            onChange={onChangeView}
          />
        ) : null}
        {ScopeControl ? (
          <ScopeControl
            options={BIRDVIEW_SCOPE_OPTIONS}
            value={scope}
            onChange={onChangeScope}
          />
        ) : null}
        <div className={styles.actions} ref={actionsContainerRef} />
        {onResetLayout ? (
          <Button.Outlined
            isGrey
            height={BUTTON_HEIGHT_32}
            qaName={QA_NAME_DASHBOARD_BIRDVIEW_RESET_LAYOUT}
            text={t('DashboardBirdview.ResetLayoutButtonTextKey')}
            onClick={onResetLayout}
          />
        ) : null}
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: RefreshIcon }}
          height={BUTTON_HEIGHT_32}
          isLoading={isRefreshing}
          qaName={QA_NAME_DASHBOARD_BIRDVIEW_REFRESH}
          tooltip={t('Common.RefreshButtonTextKey')}
          onClick={onRefresh}
        />
      </div>
    </header>
  )
}

export default BirdviewHeader
